// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EkD6","comment":"styles_comment__1eRfN"};